module.exports = __webpack_public_path__ + "17d2ac1319d15226282b64aae318904a.woff";


//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-grid/fonts/ui-grid.woff
// module id = 8
// module chunks = 0